import i18n from "../../../../Utils/i18next/i18next";
import store from "../../../../store";
import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { cloneDeep, set } from "lodash";
import { updateDashboardByName } from "../../../../Utils/Sockets";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { crmReducer } = store.getState();
  const {
    updateTableRegistry,
    loadData,
    update,
    updateSingleRegistry,
    uuid,
    initialValues,
  } = props;

  const data = cloneDeep(values);

  const isStep1Touched =
    values.eventType ||
    values.representative ||
    values.representativeDecisionType ||
    values.eventDescription ||
    values.nextEventDate ||
    values.nextEventTime ||
    values.offer ||
    values.offerStatus ||
    values.nextEventType;

  if (values?.clientType?.value)
    set(data, "clientType", values?.clientType?.value);

  if (values?.representative?.value)
    set(data, "representative.uuid", values?.representative?.value);

  if (values?.clientOrigin?.value)
    set(data, "clientOrigin.uuid", values?.clientOrigin?.value);
  if (values?.processGoal?.value)
    set(data, "processGoal.uuid", values?.processGoal?.value);
  if (values?.prognosis?.value)
    set(data, "prognosis.uuid", values?.prognosis?.value);
  if (values?.acquisitionSource?.value)
    set(data, "acquisitionSource.uuid", values?.acquisitionSource?.value);

  if (values?.offerStatus?.value)
    set(data, "offerStatus", values?.offerStatus?.value);

  // ZAKŁADKA EVENT
  if (values?.eventType?.value)
    set(data, "eventType", values?.eventType?.value);

  if (values?.representativeDecisionType?.value)
    set(
      data,
      "representativeDecisionType",
      values?.representativeDecisionType?.value
    );

  if (values?.eventStatus?.value)
    set(data, "eventStatus.uuid", values?.eventStatus?.value);

  if (values?.nextEventType?.value)
    set(data, "nextEventType", values?.nextEventType?.value);

  if (isStep1Touched) {
    data.events = [
      {
        eventType: data.eventType,
        representative: data.representative,
        representativeDecisionType: data.representativeDecisionType,
        eventDescription: data.eventDescription ? data.eventDescription : "",
        nextEventDate: data.nextEventDate ? data.nextEventDate : null,
        nextEventTime: data.nextEventTime ? data.nextEventTime : null,
        offer: data.offer ? data.offer : false,
        offerStatus: data.offerStatus ? data.offerStatus : null,
        eventStatus: data.eventStatus ? { uuid: data.eventStatus.uuid } : null,
        nextEventType: data.nextEventType ? data.nextEventType : null,
      },
    ];
    delete data.eventType;
    delete data.representative;
    delete data.representativeDecisionType;
    delete data.eventDescription;
    delete data.nextEventDate;
    delete data.nextEventTime;
    delete data.offer;
    delete data.offerStatus;
    delete data.eventStatus;
    delete data.nextEventType;
  }

  let payload;

  if (!update) {
    data.status = crmReducer?.availableStatuses.find((el) => !!el.isSelected);

    const res = await GlobalAuthFetch({
      path: `/crm`,
      method: "POST",
      data,
    });
    payload = res.payload;
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/crm/${uuid}`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);

    return;
  }

  props.setErrorHeader(0, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();

  props.handleHide();
};

export const onValidate = (values, props) => {
  const { update } = props;
  const errorsStep0 = {};
  const errorsStep1 = {};
  const errorsStep2 = {};

  if (!values.contractor) {
    errorsStep0.contractor = t("global:crm.errors.contractor");
  }

  if (
    (update && !values.participantsArr) ||
    values.participantsArr?.length < 1
  ) {
    errorsStep2.participantsArr = t("global:analyst.errors.participantsArr");
  }

  const isStep1Touched =
    values.eventType ||
    values.representative ||
    values.representativeDecisionType ||
    values.eventDescription ||
    values.nextEventDate ||
    values.nextEventTime ||
    values.offer ||
    values.eventStatus ||
    values.offerStatus ||
    values.nextEventType;

  if (isStep1Touched) {
    if (!values.eventType) {
      errorsStep1.eventType = t("global:crm.errors.eventType");
    }
    if (!values.representative) {
      errorsStep1.representative = t("global:crm.errors.representative");
    }

    if (!values.representativeDecisionType) {
      errorsStep1.representativeDecisionType = t(
        "global:crm.errors.representativeDecisionType"
      );
    }

    if (!values.eventStatus) {
      errorsStep1.eventStatus = t("global:crm.errors.eventStatus");
    }
  }

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    !props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }
  if (
    !props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length > 0
  ) {
    props.setErrorHeader(1, true);
  }
  if (
    !!props.steps[1]?.error &&
    !props.isSubmit &&
    Object.keys(errorsStep1).length <= 0
  ) {
    props.setErrorHeader(1, false);
  }
  if (
    !props.steps[2]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep2).length > 0
  ) {
    props.setErrorHeader(2, true);
  }
  if (
    !!props.steps[2]?.error &&
    !props.isSubmit &&
    Object.keys(errorsStep2).length <= 0
  ) {
    props.setErrorHeader(2, false);
  }

  return { ...errorsStep0, ...errorsStep1, ...errorsStep2 };
};
